import React from 'react';
import { SelectInput } from 'react-admin';
import { CoolerType, OrderService, OrderServiceActiveChoices } from '../../../../entities';
import { useForm } from 'react-final-form';


export const ServiceInputRaw = props => {
	return (
		<SelectInput {...props} choices={OrderServiceActiveChoices} />
	);
}

export const ServiceInput = props => {
	const form = useForm();

	const handleServiceChange = (e) => {
		const service = e.target.value;
		switch (service) {
			case OrderService.reloadCarCar:
				form.change('cooler_type_id', CoolerType.other);
				break;
			case OrderService.reloadCarTerminalCar:
				form.change('cooler_type_id', CoolerType.cooler);
				break;
			case OrderService.intoPlukkStorage:
				form.change('cooler_type_id', CoolerType.cooler);
				break;
			case OrderService.crossDock:
				form.change('cooler_type_id', CoolerType.cooler);
				break;
			default:
				break;
		}
		form.change('service', service);
	}

	return (
		<ServiceInputRaw {...props} onChange={handleServiceChange} />
	);
};
